import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import { IApiLink } from "@/types"
import { AssetType, IGetAssetTypeDto } from "./AssetType"

export interface IGetAssetTypesDto {
    entities?: IGetAssetTypeDto[]
    links?: IApiLink[]
}

export default class AssetTypes {
    items?: AssetType[]
    linkCreateAssetType?: IApiLink
    linkUpdateAssetType?: IApiLink

    constructor({
        entities,
        links
    }: IGetAssetTypesDto) {
        this.items = entities?.map(atDto => new AssetType(atDto))
        this.linkCreateAssetType = links?.find(lnk =>
            lnk.entity === ApiLinkEntity.assetType
            && lnk.rel === ApiLinkRel.new
        )
        this.linkUpdateAssetType = links?.find(lnk =>
            lnk.entity === ApiLinkEntity.assetType
            && lnk.rel === ApiLinkRel.partialUpdate
        )
    }

    get canCreate(): boolean {
        return !!this.linkCreateAssetType
    }
}
